import { db } from "../../../config/firebaseconfig";

export default function getAllDistrictsAndSchools () {
  const getDistricts = db.collection('districts').get()
  const getSchools = db.collection('schools').get()
  return Promise.all([getDistricts, getSchools]).then((results) => {
    let accounts = {districts: {}, schools: {}}
    results[0].forEach((doc) => {
      if (doc.exists) {
        accounts.districts[doc.id] = doc.data()
      }
    })
    results[1].forEach((doc) => {
      if (doc.exists) {
        accounts.schools[doc.id] = doc.data()
      }
    })
    return accounts
  })
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/getAllDistrictsAndSchools.js